<template>
  <BaseVeeForm
    :action="deleteEmailTemplate"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
  >
    <VModal ref="modal" @modal:hidden="$emit('close')" :disable-backdrop-click="isPending">
      <div class="mx-auto w-full max-w-lg">
        <BaseCard>
          <BaseCardBody>
            <div class="space-y-1 mb-8">
              <h3 class="text-lg leading-6 font-medium text-gray-900">Delete Email Message</h3>
              <p class="max-w-2xl text-sm text-gray-500">Permanently remove this email message.</p>
            </div>
            <ValidationProvider :rules="{ required: { allowFalse: false } }" name="confirmed" slim>
              <template #default="{ errors }">
                <BaseFormGroup>
                  <div class="flex items-baseline">
                    <BaseFormCheckbox v-model="confirmed" :disabled="isPending" />
                    <p class="inline-block ml-2 measure">
                      I understand that by deleting this email message, all of its resources and
                      data will be permanently removed.
                    </p>
                  </div>
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="isPending || invalid"> Delete </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </div>
    </VModal>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
    emailMessage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      confirmed: false,
    };
  },
  methods: {
    async deleteEmailTemplate() {
      try {
        await this.action(this.emailMessage.id);

        this.$emit('deleted', this.emailMessage);

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
